import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import Popover from "module-common/Popover";
import TreeView from "module-common/TreeView";

export default class Picker extends Component {
  static propTypes = {
    position: PropTypes.oneOf(["top", "bottom"]),
    children: PropTypes.any,
    tree: PropTypes.array,
    width: PropTypes.number,
    maxMenuScroll: PropTypes.number,
    onSelected: PropTypes.func,
    onChange: PropTypes.func
  };
  static defaultProps = {
    position: "bottom",
    tree: [],
    width: 200,
    maxMenuScroll: 10
  };

  render() {
    const { children, tree, hideOnSelect, ...rest } = this.props;
    return tree.length === 0 ? null : (
      <Popover
        {...rest}
        ref={ref => (this.popover = ref)}
        show="click"
        hide="click-outside"
        content={this.renderTree()}
      >
        {children}
      </Popover>
    );
  }

  renderTree = () => {
    const { tree, width, position, maxMenuScroll, onChange } = this.props;
    let count = tree.length;
    if (count > maxMenuScroll) count = maxMenuScroll;
    return (
      <Menu position={position} height={count * 40 + 12} width={width}>
        <Scrollbars>
          <TreeView
            tree={tree}
            renderNode={this.renderNode}
            onChange={onChange}
          />
        </Scrollbars>
      </Menu>
    );
  };

  renderNode = (level, node, notifyChange) => {
    const hasChildren = node.children && node.children.length > 0;
    let collapsibleContent;
    let collapsibleOnClick;
    if (hasChildren) {
      if (node.isCollapsed) {
        collapsibleContent = "\u25B8";
      } else {
        collapsibleContent = "\u25BE";
      }
      collapsibleOnClick = evt => {
        node.isCollapsed = !node.isCollapsed;
        notifyChange();
      };
    }

    return (
      <NodeWrapper level={level}>
        <Collapsible color={node.value.color} onClick={collapsibleOnClick}>
          {collapsibleContent}
        </Collapsible>
        <Node
          selected={node.selected}
          onClick={() => {
            // node.selected = !node.selected;
            // notifyChange();
            this.popover.hide();
            this.onNodeClick(node);
          }}
        >
          {node.label}
        </Node>
      </NodeWrapper>
    );
  };

  onNodeClick = node => {
    const { tree, onSelected } = this.props;
    if (onSelected) onSelected(node, tree);
  };
}

const Menu = styled.div`
  padding: 6px 0px;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border-radius: 12px;
  box-shadow: ${props => props.theme.shadow};
  background-color: white;
  word-break: keep-all;
  overflow-wrap: break-word;
`;
const NodeWrapper = styled.div`
  display: flex;
  margin-left: ${props => props.level * 10 + "px"};
`;
const Collapsible = styled.div.attrs({
  style: props => ({
    backgroundColor: "#" + props.color,
    cursor: props.onClick ? "pointer" : "auto"
  })
})`
  display: flex;
  flex: none;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  font-size: 1.1rem;
  margin-top: 11px;
  margin-left: 10px;
  margin-right: 4px;
  line-height: 0.6;
  color: white;
  user-select: none;
`;
const Node = styled.div`
  width: 100%;
  margin-right: 10px;
  padding: 8px;
  margin-bottom: 5px;
  color: ${props => props.theme.uiText};
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
  &:first-letter {
    text-transform: capitalize;
  }
  &:hover {
    background-color: ${props => props.theme.blueButton};
    color: white;
    border-radius: 4px;
  }
  ${props =>
    props.selected &&
    css`
       {
        background-color: ${props.theme.blueButton};
        color: white;
        border-radius: 4px;
      }
    `};
`;



// WEBPACK FOOTER //
// ./src/module-common/TreePicker.js